import { TAG_CODES } from "../../tag.config"

const GOM_TRAFFIC_DIRECTION = {
    type: 'path',
    tagCode: TAG_CODES.ROAD,
    withText: true,
    defaultText: 'Direction',
    positionText: 'top', // top - right - center - bottom - left
    fieldsText: ["title"],
    endTextWidthStr: "",
    angle: 0,
    colorCodeId: 'default',
    withFillColor: true,
    schema: {
        "type": 'object',
        "properties": {
            "title": {
                "title": "Text",
                "description": "Write a text",
                "type": "string",
            },
        },
        "required": []
    },
    pathData: `M20 50H130M20 60H130ZM130 60 106 70 106 60Z`,
}

export default GOM_TRAFFIC_DIRECTION